<script lang="ts" setup>
import { request } from "@/services/request";

const config = useRuntimeConfig();
const onboardingStore = useOnboardingStore();
const currentApiSubscribe = computed(
  () => `${config.public.baseApiEnpoint}/api/marketing/blog-subscriptions`
);

const inputText = "Email Address";
const btnName = "Subscribe";
const thanksMsg = "Thanks for subscribing!";
const errorMessage = ref("Something went wrong. Please try again.");
const email = ref("");
const showSuccessMessage = ref(false);
const showErrorMessage = ref(false);
const emailError = ref(false);

const submitForm = () => {
  showSuccessMessage.value = false;
  showErrorMessage.value = false;
  errorMessage.value = "";

  if (!validateEmail(email.value)) {
    emailError.value = true;
    showSuccessMessage.value = false;
    return;
  }
  emailError.value = false;

  const formData = {
    email: email.value,
    pageUrl: window.location.href,
    abandonedCartId: onboardingStore.abandonedCartId,
  };

  request
    .post(currentApiSubscribe.value, formData)
    .then(() => {
      showSuccessMessage.value = true;
      email.value = "";
    })
    .catch(
      (error: { response: { data: { message: string } }; message: string }) => {
        console.error("There was a problem with your submission:", error);
        if (error.response && error.response.data) {
          errorMessage.value =
            error.response.data.message || "Unknown error occurred";
        } else {
          errorMessage.value = error.message || "Unknown error occurred";
        }
        showErrorMessage.value = true;
        showSuccessMessage.value = false;
      }
    );
};
</script>

<template>
  <div class="tw-pb-2.5 sm:tw-pb-[30px]">
    <div class="tw-container max-md:tw-px-[17px]">
      <strong
        class="tw-font-bookmania tw-block tw-text-[14px] sm:tw-text-[22px] tw-leading-[1.35] tw-font-medium tw-text-center tw-mb-3 sm:tw-mb-[39px]"
      >
        Subscribe to get notified when we’ve added new resources.
      </strong>
      <form
        id="form-newsletter"
        class="subscribe-form"
        @submit.prevent="submitForm"
      >
        <div class="tw-flex tw-flex-wrap tw-items-center tw-max-w-[686px] tw-mx-auto tw-mb-5">
          <div class="tw-flex-1 tw-pr-[7px] sm:tw-pr-[15px]">
            <input
              id="email-inputter"
              v-model="email"
              required
              name="email"
              class="tw-font-agenda tw-w-full tw-rounded-[40px] tw-placeholder-[#707070]/50 tw-leading-[1.5] md:tw-leading-[1.25] tw-text-base md:tw-text-[22px] tw-tw-font-medium tw-px-[37px] md:tw-px-[41px] tw-pt-2 md:tw-pt-[14px] tw-pb-[9px] md:tw-pb-[18px] tw-border-2 tw-border-[#707070]"
              :class="{ 'tw-border-red-500 tw-border-2 error': emailError }"
              type="email"
              :placeholder="inputText"
            />
          </div>
          <input
            type="submit"
            class="btn max-md:tw-px-2.5 max-md:tw-py-[9px] md:tw-text-[22px] tw-min-w-[120px] md:tw-min-w-[242px] tw-rounded-[50px] tw-bg-[#004B2C] hover:tw-bg-[#65b031] md:tw-h-[59px] md:tw-leading-[1.4] tw-cursor-pointer"
            :value="btnName"
          />
        </div>
        <div class="sm:tw-min-h-[29px]">
          <strong
            v-if="showSuccessMessage"
            class="success-message tw-text-center tw-block tw-text-nl-green-200 tw-text-[14px] sm:tw-text-[22px] tw-leading-[1.35] tw-font-bold"
          >
            {{ thanksMsg }}
          </strong>
          <strong
            v-if="showErrorMessage"
            class="error-message tw-text-center tw-block tw-text-red-500 tw-text-[14px] sm:tw-text-[22px] tw-leading-[1.35] tw-font-bold"
          >
            {{ errorMessage }}
          </strong>
        </div>
      </form>
    </div>
  </div>
</template>
